import React from 'react';

import { ON_OFF_COURTS, ON_OFF_STATS } from '../on-off-reports';

const Header = ({ onSortChange, sortKey }) => (
  <thead>
    <tr>
      <th></th>
      {ON_OFF_COURTS.map(court => (
        <CourtHeaderCell key={`header-court${court.court}`} court={court} />
      ))}
    </tr>

    <tr>
      <th></th>
      {ON_OFF_COURTS.map(court =>
        ON_OFF_STATS.map(stat => (
          <StatHeaderCell
            key={`header-${court.court}-${stat.stat}`}
            court={court}
            stat={stat}
            onSortChange={onSortChange}
            sortKey={sortKey}
          />
        )),
      )}
    </tr>
  </thead>
);

export default Header;

const CourtHeaderCell = ({ court: { court, stats, name } }) => (
  <th
    colSpan={stats.length}
    key={court}
    className="stats-table__column-title court-title"
    title={name}
  >
    {name}
  </th>
);

const StatHeaderCell = ({ court, stat, onSortChange, sortKey }) => {
  if (!hasCourtStat(court, stat)) return null;

  const selected =
    sortKey && court.court === sortKey[0] && stat.stat === sortKey[1];
  let arrow = '';
  if (selected && sortKey[2]) {
    arrow = '&#10515;';
  } else if (selected && !sortKey[2]) {
    arrow = '&#10514;';
  }

  return (
    <th
      key={`${court.court}-${stat.stat}`}
      className={`stats-table__column-title ${selected ? 'selected' : ''}`}
      title={stat.name}
    >
      <span
        className="stats-table__column-title__sortable"
        onClick={() => onSortChange(court.court, stat.stat)}
      >
        {stat.name} <span dangerouslySetInnerHTML={{ __html: arrow }} />
      </span>
    </th>
  );
};

function hasCourtStat(court, stat) {
  return court.stats.indexOf(stat.stat) !== -1;
}
